module.exports = __webpack_public_path__ + "static/media/logo-conecta-responde.cc439ea7.svg";